import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Main',
		component: () => import('../views/Main'),
		children: [{
			path: '',
			name: 'Home',
			component: () => import('../views/Home')
		},
		{
			path: 'build',
			name: 'Build',
			component: () => import('../views/Build')
		},
		{
			path: 'about',
			name: 'About',
			component: () => import('../views/About')
		}]
	},
	{
		path: '*',
		name: 'NotFound',
		component: () => import('../views/NotFound')
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
